import { Component } from '@angular/core';

@Component({
  selector: 'ui-divider',
  templateUrl: './divider.component.html'
})
export class DividerComponent {
}